import { Component, inject } from '@angular/core';
import { Login } from '../../login/login';
import { AuthStore } from '../../../authentication/authStore';
import { NzSpinComponent } from 'ng-zorro-antd/spin';

@Component({
  selector: 'single-layout',
  imports: [Login,NzSpinComponent],
  templateUrl: './single-layout.html',
  styleUrls: ['./single-layout.scss']
})
export class SingleLayout {
  auth = inject(AuthStore)
}
